import { render, staticRenderFns } from "./SocialDistancing.vue?vue&type=template&id=dd0781a6&scoped=true&"
import script from "./SocialDistancing.vue?vue&type=script&lang=js&"
export * from "./SocialDistancing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0781a6",
  null
  
)

export default component.exports